"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cookieSupportChecks = require("./cookieSupportChecks");
var cookieDomain = process.env.REACT_APP_GOOGLE_OAUTH_COOKIE_DOMAIN || process.env.NEXT_PUBLIC_GOOGLE_OAUTH_COOKIE_DOMAIN;
var ONE_DAY_IN_MILLISECONDS = 60 * 60 * 1000;
var getExpiryDate = function getExpiryDate(expiry_date) {
  if (typeof expiry_date === 'number') return new Date(expiry_date).toGMTString();
  if (typeof expiry_date === 'string' && !isNaN(new Date(expiry_date).getTime())) {
    /* date is valid */
    return expiry_date;
  }
  return new Date(ONE_DAY_IN_MILLISECONDS).toGMTString();
};
var setCookie = function setCookie(name, value, expiry_date /* in milliseconds */) {
  document.cookie = "".concat(name, "=").concat(value, ";path=/;expires=").concat(getExpiryDate(expiry_date), ";domain=").concat(cookieDomain, ";secure;samesite=").concat((0, _cookieSupportChecks.isSameSiteStrictSupported)() ? 'strict' : 'lax', ";");
};
var _default = exports["default"] = setCookie;